var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NSelect',{attrs:{"items":_vm.items,"item-text":"name","item-value":"id","label":_vm.label,"readonly":_vm.readonly,"clearable":_vm.clearable,"rules":_vm.rules,"required":_vm.required,"placeholder":_vm.placeholder},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }